import React from 'react';
import { motion } from 'framer-motion';
import { OtlIntro } from './otl/OtlIntro';
import { OtlParamoExample } from './otl/OtlParamoExample';
import { OtlEnvironmental } from './otl/OtlEnvironmental';
import { OtlList } from './otl/OtlList';
import { OtlVisor } from './otl/OtlVisor';
import { OtlVideo } from './otl/OtlVideo';
export function MapVisor() {
  return <section id="resultados" className="py-24 md:py-32 px-4 md:px-8 scroll-mt-24" data-id="element-283" data-mp="2660iy84yrrcd">
      <div className="max-w-[1400px] mx-auto" data-id="element-284" data-mp="18mfhmloipscf">
        <div className="max-w-3xl mb-16 md:mb-20" data-id="element-285" data-mp="1dj601fnsp010">
          <motion.span initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="block text-clay uppercase tracking-[0.2em] text-xs font-semibold mb-5" data-id="element-286" data-mp="1dhmillqekixn">
            Objetos Territoriales Legales (OTL)
          </motion.span>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-4xl md:text-5xl font-serif text-forest leading-tight" data-id="element-287" data-mp="uso7bb2yq4fn">
            Información clara para conocer, consultar y cuidar el territorio
          </motion.h2>
        </div>
        <OtlParamoExample data-id="element-288" data-mp="xegdefa0bpsk" />
        <OtlIntro data-id="element-289" data-mp="xf9aeoj5z0xi" />
        <OtlVisor data-id="element-290" data-mp="xdopzrqkcydd" />
        <OtlEnvironmental data-id="element-291" data-mp="sg53y5nmjhav" />
        <OtlList data-id="element-292" data-mp="shg3tudy84wp" />
        <OtlVideo data-id="element-293" data-mp="shzmxefc4zcb" />
      </div>
    </section>;
}